import { takeLatest, put, call, select } from 'redux-saga/effects';
import { BOOKING_ACTION_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';
import { getBookingSagaAction, getMyReservesSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/booking_action`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerBookingAction(args) {
    const user = yield select(state => state.user);
    const est = yield select(state => state.est);
    const booking = yield select(state => state.booking);
    const my_reserves = yield select(state => state.my_reserves);

    yield put(loadingAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('user_hash', user.hash);
        formData.append('booking_id', args.data?.booking_id);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            // Если открыто окно «Мои записи», обновляем информацию в нём
            if (my_reserves.open) {
                yield put(getMyReservesSagaAction());
            }
            yield put(getBookingSagaAction({ date: booking.date }));
            toast.success(response.message);
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherBookingAction() {
    yield takeLatest(BOOKING_ACTION_SAGA, workerBookingAction);
}